import { Image, Text, View } from "@react-pdf/renderer";
import pdfConstants from "../util/PDFConstants";

function PDFHeader(props) {
    return (
        <View style={pdfConstants.pdfStyles.mainHeader}>
            { props.noImage == null || props.noImage === false ?
                <Image
                    style={pdfConstants.pdfStyles.logo}
                    src={pdfConstants.default_logo_image}
                />
                :
                <></>
            }
            <View style={pdfConstants.pdfStyles.row60NoBorder}>
                <Text style={pdfConstants.pdfStyles.bigColumn90Client}>
                    { props.title }
                </Text>
                <Text style={pdfConstants.pdfStyles.smallColumn}>
                    &nbsp;
                </Text>
            </View>
        </View>
    )
}

export default PDFHeader;